import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { Alert } from "reactstrap";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ReactLoading from "react-loading";
import { GoogleLogin } from "@react-oauth/google";
import { GoogleOAuthProvider } from "@react-oauth/google";

function Progress(props) {
  const { submitted, refreshPage } = props;

  const delay = 5;

  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer1 = setTimeout(() => setShow(true), delay * 1000);
    return () => {
      clearTimeout(timer1);
    };
  }, []);
  return show ? (
    refreshPage()
  ) : (
    <React.Fragment>
      <style>
        {`
        .loader {
          // background: #ffffff;
          color: #ffffff;
          bottom: 0;
          left: 0;
          opacity: 0.8;
          position: absolute;
          right: 0;
          top: 0;
      }
      
      .loader,
      .loader-content {
          display: flex;
          align-items: center;
          justify-content: center;
      }
      
      .loader-message {
          font-size: 1.5em;
          margin-top: 1em;
          align-items: center;
      }
      `}
      </style>
      <div className="loader">
        <div className="loader-content">
          <ReactLoading
            type="spinningBubbles"
            color="#ffffff"
            height={300}
            width={150}
          />
        </div>
      </div>
      <div className="loader">Loading ...</div>
    </React.Fragment>
  );
}

export default function Login() {
  const [state, setState] = useState({
    email: "",
    password: "",
    errorMessage: "",
    errorMessage1: "",
    submitted: false,
    handleChange: false,
    showPassword: false,
  });

  console.log(state);

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const CLIENT_ID = `${process.env.REACT_APP_CLIENTID}`;
  const responseGoogle = (response) => {
    const google = {
      auth_token: response.credential,
    };
    fetch(`${process.env.REACT_APP_API_URL}/social_auth/google/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(google),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.tokens) {
          localStorage.setItem("user", data.username);
          localStorage.setItem("email", data.email);
          localStorage.setItem("token", data.tokens.access);
          localStorage.setItem("google", "google");
          window.location.href = "/admin/index";
        } else {
          if (data.email) {
            console.log(data);
            setState({ email: "" });
            setState({ password: "" });
            setState({ errorMessage: data.email[0] });
            setVisible(true);
          } else {
            setState({ errorMessage: data.detail });
            setVisible(true);
          }
        }
      })
      .catch((error) => {
        console.error(error);
        localStorage.removeItem("token");
      });
  };
  const failureGoogle = (response) => {
    console.log(response);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleEmailChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (!pattern.test(value)) {
      const id1 = "errorMessage1";
      setState((prevState) => ({
        ...prevState,
        [id1]: "Please enter a valid email id",
      }));
    } else {
      const id1 = "errorMessage1";
      setState((prevState) => ({
        ...prevState,
        [id1]: "",
      }));
    }
  };

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  function refreshPage() {
    window.location.reload();
  }

  const handleSubmitClick = (e) => {
    setState({ handleChange: false });
    const login = {
      email: state.email,
      password: state.password,
    };
    setState({ submitted: true });
    fetch(`${process.env.REACT_APP_API_URL}/auth/login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(login),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.tokens && data.email && data.username) {
          localStorage.setItem("user", data.username);
          localStorage.setItem("email", data.email);
          localStorage.setItem("token", data.tokens.access);
          setState({ submitted: true });
          fetch(
            `${process.env.REACT_APP_API_URL}/api/user_management/user_list/`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
            .then((resp) => resp.json())
            .then((data) => {
              if (data.detail) {
                localStorage.setItem("user_access", data.detail);
                window.location.href = "/admin/dashboard";
              }
            });
          setState({ submitted: true });
          fetch(`${process.env.REACT_APP_API_URL}/api/run_audit`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
            .then((resp) => resp.json())
            .then((data) => {
              if (data.detail) {
                localStorage.setItem("audit_run_access", data.detail);
              }
            });
          setState({ submitted: true });
          fetch(`${process.env.REACT_APP_API_URL}/api/run_remedy`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
            .then((resp) => resp.json())
            .then((data) => {
              if (data.detail) {
                localStorage.setItem("remedy_run_access", data.detail);
              }
            });

          setState({ submitted: true });
          fetch(`${process.env.REACT_APP_API_URL}/api/run_rollback`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
            .then((resp) => resp.json())
            .then((data) => {
              if (data.detail) {
                localStorage.setItem("rollback_run_access", data.detail);
                window.location.href = "/admin/dashboard";
              }
            });
        } else {
          setState({ email: "" });
          setState({ password: "" });
          setVisible(true);
          if (data.email) {
            setState({ email: "" });
            setState({ password: "" });
            setState({ errorMessage: data.email[0] });
            setVisible(true);
          } else if (data.password) {
            setState({ email: "" });
            setState({ password: "" });
            setState({ errorMessage: data.password[0] });
            setVisible(true);
          } else if (data.password && data.email) {
            setState({ email: "" });
            setState({ password: "" });
            setState({ errorMessage: data.email[0] });
            setVisible(true);
          } else {
            setState({ email: "" });
            setState({ password: "" });
            setState({ errorMessage: data.detail });
            setVisible(true);
          }
        }
      })
      .catch((error) => {
        console.error(error);
        localStorage.removeItem("token");
      });
  };

  const handleKeypress = (e) => {
    if (e.key === "Enter") {
      handleSubmitClick();
    }
  };
  return (
    <div>
      {state.submitted ? (
        <Progress submitted={state.submitted} refreshPage={refreshPage} />
      ) : (
        <div className="container mx-auto px-4 h-full">
          <div className="flex content-center items-center justify-center h-full">
            <div className="w-full lg:w-4/12 px-4">
              <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
                <div className="rounded-t mb-0 px-6 py-6">
                  <div className="text-center mb-3">
                    <img
                      style={{
                        width: "50%",
                        height: "50%",
                        class: "center",
                        marginLeft: "auto",
                        marginRight: "auto",
                        display: "block",
                      }}
                      alt="..."
                      src={
                        require("../../assets/img/AutomateCIS_logo.svg").default
                      }
                    />
                  </div>

                  <div className="text-blueGray-400 text-center mb-3 font-bold">
                    <small>Sign in with</small>
                  </div>

                  <div
                    className="btn-wrapper text-center"
                    style={{
                      textAlign: "-webkit-center",
                    }}
                  >
                    <GoogleOAuthProvider
                      className="loginBtn loginBtn--google"
                      onClick={responseGoogle}
                      clientId={CLIENT_ID}
                      color="default"
                      style={{
                        marginRight: "0px",
                        theme: "#0000FF",
                        shape: "circle",
                        background: "rgb(255 255 255)",
                        padding: "0px",
                        borderRadius: "200px",
                        mixBlendMode: "overlay",
                      }}
                    >
                      <GoogleLogin
                        onSuccess={responseGoogle}
                        onError={failureGoogle}
                      />
                    </GoogleOAuthProvider>
                  </div>

                  <hr className="mt-2 border-b-1 border-blueGray-300" />
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                  <div className="text-blueGray-400 text-center mb-1 font-bold">
                    <small>Or sign in with credentials</small>
                  </div>

                  {state.errorMessage && !state.submitted && (
                    <Alert
                      style={{
                        color: "red",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                      isOpen={visible}
                      toggle={onDismiss}
                    >
                      {" "}
                      {state.errorMessage}{" "}
                    </Alert>
                  )}

                  <form>
                    <div className="relative w-full mb-1">
                      <label
                        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Email
                      </label>
                      <TextField
                        fullWidth
                        type="text"
                        id="email"
                        className="form-control"
                        value={state.email}
                        onChange={handleEmailChange}
                        onKeyPress={handleKeypress}
                        variant="outlined"
                        size="small"
                        placeholder="Email"
                      />
                    </div>

                    {state.errorMessage1 ? (
                      <p>
                        {" "}
                        <span style={{ color: "red", fontSize: "15px" }}>
                          {state.errorMessage1}
                        </span>
                      </p>
                    ) : (
                      ""
                    )}

                    <div className="relative w-full mb-1">
                      <label
                        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                        htmlFor="grid-password"
                      >
                        Password
                      </label>
                      <OutlinedInput
                        fullWidth
                        htmlFor="password"
                        placeholder="Enter the password ..."
                        type={state.showPassword ? "text" : "password"}
                        autoComplete="new-password"
                        name="password"
                        id="password"
                        className="form-control"
                        onChange={handleChange}
                        onKeyPress={handleKeypress}
                        value={state.password}
                        size="small"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {state.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </div>
                    <div className="text-center mt-6">
                      <button
                        className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                        type="button"
                        onClick={handleSubmitClick}
                        disabled={state.submitted ? true : false}
                      >
                        Sign In
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="flex flex-wrap mt-6 relative">
                <div className="w-1/2">
                  <Link
                    to={{ pathname: "https://www.zippyops.com/contact-us" }}
                    target="_blank"
                    className="text-blueGray-200"
                  >
                    <small>Contact us</small>
                  </Link>
                </div>

                <div className="w-1/2 text-right">
                  <Link to="/auth/register" className="text-blueGray-200">
                    <small>Create new account</small>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}